<div class="divider" />

<style lang="scss">
  .divider {
    border-bottom: 1px solid #d3d3d3;
  }
</style>
